import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FAQ({ items, title = "Questions fréquentes" }) {
  const [open, setOpen] = useState(0);
  if (!items || items.length === 0) return null;

  return (
    <section data-testid="faq-section" className="py-20 lg:py-28 bg-white border-t border-zinc-200">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <p className="font-mono-tech text-sm uppercase tracking-[0.2em] text-[#E63946] font-semibold">FAQ</p>
        <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">{title}</h2>

        <div className="mt-10 divide-y divide-zinc-200 border-t border-zinc-200">
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="font-display text-lg font-bold tracking-tight text-[#0A0A0A] group-hover:text-[#E63946] transition-colors">
                    {it.q}
                  </span>
                  <span className="grid h-8 w-8 place-items-center rounded-sm border border-zinc-200 shrink-0 text-[#0A0A0A]">
                    {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-5 pr-12 text-[#52525B] leading-relaxed">{it.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
